"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parsePayload = void 0;
/* eslint-disable no-undef */
/* eslint-disable import/prefer-default-export */
/* eslint-disable no-unused-vars */
var conversions_1 = require("../../../../utils/conversions");
// Check byte size of a string
var byteSize = function (str) { return new Blob([str]).size; };
var parsePayload = function (request) {
    return new Promise(function (resolve, reject) {
        var bytesString = [
            request.country_config,
            request.challenge,
            request.challenge_signature,
            request.country_config_signature,
        ].join('');
        var MAX_DATA_SEND_SIZE = 16;
        var payloadByteSize = byteSize(bytesString) / 2;
        var h2ab = (0, conversions_1.hexStringToArrayBuffer)(['0x', bytesString].join(''));
        var payloadChunks = (0, conversions_1.splitArrayIntoChunks)(h2ab, MAX_DATA_SEND_SIZE);
        if (payloadChunks.length === 0) {
            throw new Error('Missing payload data');
        }
        resolve({ payload: payloadChunks, payloadByteSize: payloadByteSize });
    });
};
exports.parsePayload = parsePayload;
